import FingerprintJS from '@fingerprintjs/fingerprintjs';

const fingerprint = FingerprintJS.load();

export const getFingerprint = async (): Promise<string> => {
    const fp = await fingerprint;
    const result = await fp.get();

    return result.visitorId;
};
